import React from "react";

export default props => <div className="layout">{props.children}</div>;
